// extracted by mini-css-extract-plugin
export default {"inputContainer":"gHoCzt","selectedText":"ZhTfcb","text":"LWWbqK","icon":"vZKfIk"};